import React from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import ideaActionsFactory from "../ideaActions";
import IdeaDetailsController from "./IdeaDetailsController";
import {logAction} from "../../../logging/logEvent";
import {CloseModalButton} from "./ExitModalButton";
import {tableBorderColour} from "../../../style/styleConsts";

const modalStyle = {
    overlay: {
        background: "rgba(0,0,0,0.4)"
    },
    content: {
        position: 'absolute',
        overflow: 'visible',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        outline: 'none',
        padding: '0px',
        minHeight: '540px',
        minWidth: '720px',
        marginTop: '32px',
        marginBottom: '32px',
        marginLeft: '40px',
        marginRight: '40px',
    }
};

const Content = styled.div`
    display: flex;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    border-radius: 4px;
    border: none;
    box-shadow: 0 1px 2px 2px ${tableBorderColour};
    -webkit-overflow-scrolling: touch;
`;

function doNothing() { }

const IdeaDetailsModal = ({checkIdeaClosed, onExit = doNothing}) => {
    const ideaDetails = useSelector(state => state.ideaDetails);
    const dispatch = useDispatch();

    const ideaActions = ideaActionsFactory(dispatch);

    function closeModal() {
        ideaActions.close();
        onExit();
        logAction({type: "Idea Details Modal Closed"})
    }

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={ideaDetails.displayed}
            contentLabel="Idea Details"
            onRequestClose={closeModal}
            style={modalStyle}>
            <CloseModalButton closeModal={closeModal}/>
            <Content>
                <IdeaDetailsController closeModal={closeModal} checkIdeaClosed={checkIdeaClosed}/>
            </Content>
        </ReactModal>
    )
};

export default IdeaDetailsModal;
